/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { Text } from 'hocs/localization'
import classNames from 'classnames/bind'
import * as styles from './MaintenanceBanner.scss'
import { StringFormat } from 'shared/utils/text'
import { getPrintedDateWithTime12H } from 'shared/utils/date'
import { getFormattedTextOrDefault } from 'shared/utils/printedData'

const cx = classNames.bind(styles)

interface IProps extends RouteComponentProps {
  isMaintenanceModeOn: boolean,
  message: string,
  t: Text
}

class MaintenanceBanner extends React.Component<IProps> {
    public render () {
    const { t, isMaintenanceModeOn, message} = this.props

    return(
        <React.Fragment>
            {isMaintenanceModeOn && (
                <div className={cx('container', styles.container768)}>
                    <div className=''>
                        <div className='col-md-12'></div>
                        <div className={cx('root', 'warning')} dangerouslySetInnerHTML={{__html: message}}>                           
                </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    )
  }
}

export default MaintenanceBanner
